module.exports = __webpack_public_path__ + "static/media/now-2.ac58a163.png";